// export let colorss = {
//   primaryBackground: "rgba(80, 160, 204, 1)",
//   secondaryBackground: "rgba(56, 62, 65, 1)",
//   primaryBackgroundLight: "rgba(80, 160, 204, 0.75)",
//   primaryText: "rgba(255, 176, 0, 1)",
//   secondaryText: "rgba(217, 62, 49, 1)",
//   customColor: "rgba(231, 226, 222, 1)",
// }
export let colors = {
  primary: "rgba(80, 160, 204, 1)",
  primaryDark: "rgba(56, 62, 65, 1)",
  primaryLight: "rgba(80, 160, 204, 0.75)",
  secondary: "rgba(255, 176, 0, 1)",
  secondaryDark: "rgba(255, 176, 0, 1)",
  tertiary: "#ff3920",
  tertiaryDark: " #ff3920",
  secondaryText: "rgba(217, 62, 49, 1)",
  secondaryBackground: "rgba(56, 62, 65, 1)",
  customColor: "rgba(231, 226, 222, 1)",
  quaternary: "rgba(56, 62, 65, 1)",
}
